import { render, staticRenderFns } from "./TestMain.vue?vue&type=template&id=1d46e8ad"
import script from "./TestMain.vue?vue&type=script&lang=js"
export * from "./TestMain.vue?vue&type=script&lang=js"
import style0 from "./TestMain.vue?vue&type=style&index=0&id=1d46e8ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports